import { Link } from "react-router-dom";

export default function DarkValueSection() {
  return (
    <section className="w-full bg-foreground-950 py-20 md:py-24 px-6 md:px-10">
      <div className="max-w-7xl mx-auto text-center">
        <span className="inline-block px-3 py-1 rounded-full bg-foreground-800 text-foreground-300 text-xs font-medium mb-5">
          Why Sellers Choose Us
        </span>
        <h2 className="font-heading text-3xl md:text-5xl text-background-50 leading-tight mb-6 max-w-3xl mx-auto">
          Structured Sourcing for Modern Ecommerce Operators
        </h2>
        <p className="text-foreground-400 text-base md:text-lg max-w-xl mx-auto mb-10 leading-relaxed">
          The GTBuy Spreadsheet system brings clarity to your product sourcing.
          No more messy spreadsheets or lost supplier data &mdash; just a clean,
          repeatable workflow that grows with your store.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-14">
          <Link
            to="/what-is-gtbuy-spreadsheet"
            className="px-6 py-3 rounded-full bg-background-50 text-foreground-950 font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            Read the Guide
          </Link>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-6 py-3 rounded-full bg-transparent border border-foreground-600 text-background-50 font-medium text-sm hover:border-foreground-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            Visit KA Spreadsheet
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 max-w-4xl mx-auto">
          {[
            { icon: "ri-bar-chart-line", label: "Supplier Comparison" },
            { icon: "ri-price-tag-3-line", label: "Price Tracking" },
            { icon: "ri-file-excel-2-line", label: "Spreadsheet Export" },
            { icon: "ri-store-2-line", label: "Store Integration" },
            { icon: "ri-speed-up-line", label: "Fast Sourcing" },
          ].map((item) => (
            <div
              key={item.label}
              className="flex flex-col items-center gap-3 p-5 rounded-xl bg-foreground-900/60 hover:bg-foreground-800/60 transition-colors cursor-default"
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${item.icon} text-accent-400 text-2xl`}></i>
              </div>
              <span className="text-xs text-foreground-300 font-medium whitespace-nowrap">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}